import type { FC } from 'react';
import { Menu, ActionIcon } from '@mantine/core';
// icons
import { RefreshCw, Trash2, Edit, EllipsisVertical } from 'lucide-react';
// utils
import type { TV3Project } from '@newo/api/gateway';

interface ProjectMenuProps {
    project: TV3Project;
    onEditProject: (project: TV3Project) => void;
    onDeleteProject: (project: TV3Project) => void;
    onForceUpdateProject: (project: TV3Project) => void;
}

const ProjectMenu: FC<ProjectMenuProps> = ({
    project,
    onEditProject,
    onDeleteProject,
    onForceUpdateProject
}) => {
    const handleEditProject = () => {
        onEditProject(project);
    };

    const handleDeleteProject = () => {
        onDeleteProject(project);
    };

    const handleForceUpdateProject = () => {
        onForceUpdateProject(project);
    };

    return (
        <Menu withinPortal position="bottom-end">
            <Menu.Target>
                <ActionIcon size="lg" variant="transparent">
                    <EllipsisVertical />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item leftSection={<Edit />} onClick={handleEditProject}>
                    Edit Project
                </Menu.Item>
                <Menu.Item
                    leftSection={<RefreshCw />}
                    onClick={handleForceUpdateProject}
                >
                    Force Update Project
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item
                    className="text-red-6"
                    leftSection={<Trash2 />}
                    onClick={handleDeleteProject}
                >
                    Delete Project
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default ProjectMenu;
